import {
  VIEW_MODE_SITE,
  VIEW_MODE_DASHBOARD,
  VIEW_MODE_EDITOR,
  VIEW_MODE_PREVIEW,
} from '@wix/communities-blog-client-common/dist/src/constants/view-modes';
import Wix from './wix-sdk-polyfill';

const getViewMode = () => Wix.Utils.getViewMode();

export const isInSite = () => getViewMode() === VIEW_MODE_SITE;
export const isInEditor = () => getViewMode() === VIEW_MODE_EDITOR;
export const isInPreview = () => getViewMode() === VIEW_MODE_PREVIEW;
export const isInDashboard = () => getViewMode() === VIEW_MODE_DASHBOARD;
